import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=53bf7eee&scoped=true"
import script from "./Collapsible.vue?vue&type=script&lang=ts"
export * from "./Collapsible.vue?vue&type=script&lang=ts"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=53bf7eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf7eee",
  null
  
)

export default component.exports